import { useState, useMemo } from 'react'
import type { Notification } from '../types/notification.types'
import { mockNotifications } from '../data/mockNotifications'

export const useNotifications = () => {
    const [notifications] = useState<Notification[]>(mockNotifications)
    const [searchText, setSearchText] = useState('')
    const [activeTab, setActiveTab] = useState('all')

    const filteredNotifications = useMemo(() => {
        let filtered = notifications

        if (activeTab !== 'all') {
            filtered = filtered.filter(n => n.status === activeTab)
        }

        if (searchText) {
            const lowerSearch = searchText.toLowerCase()
            filtered = filtered.filter(n => 
                n.title.toLowerCase().includes(lowerSearch) ||
                n.recipient.toLowerCase().includes(lowerSearch) ||
                n.id.toLowerCase().includes(lowerSearch)
            )
        }

        return filtered
    }, [notifications, searchText, activeTab])

    return {
        notifications: filteredNotifications,
        searchText,
        setSearchText,
        activeTab,
        setActiveTab
    }
}
